import React from "react";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { CCard } from "@coreui/react";
import { useTranslation } from "react-i18next";
import "./ListCard.css";
import IconButton from "@mui/material/IconButton";
import { FaInfoCircle } from "react-icons/fa";
import Tooltip from "@mui/material/Tooltip";

const ListCard = ({ loading, lifestyle, title, tooltipInfo }) => {
  const { t } = useTranslation();

  return (
    <CCard className="background-card-list">
      {!loading && (
        <>
          <div className="div-row">
            <Tooltip
              title={<span className="tooltip-window">{tooltipInfo}</span>}
              arrow
            >
              <IconButton>
                <FaInfoCircle className="info-icon-list" />
              </IconButton>
            </Tooltip>
          </div>
            <h3>{title}</h3>
            {lifestyle.length !== 0 && (
              <div style={{overflowY: 'scroll', width: '90%', height:'100%', display: 'flex', 
              alignItems: 'center',flexDirection: 'column', justifyContent: lifestyle.length<=6 ? 'center' : 'flex-start'}}>
                {lifestyle.map((info, index) => (
                  <p key={index}>{t(info)}</p>
                ))}
              </div>
            )}
            {
                lifestyle.length === 0 && (
                    <>
                      {title === t("lifestyleInformation") && (
                          <div className="center-content-italic">
                            <p>{t("no_lifestyle_information")}</p>
                          </div>
                      )}
                      {title === t("pathologies") && (
                          <div className="center-content-italic">
                            <p>{t("no_pathologies")}</p>
                          </div>
                      )}
                    </>
                )
            }
        </>
      )}
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <ClipLoader
            color="white"
            loading={loading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
    </CCard>
  );
};

ListCard.propTypes = {
  lifestyle: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  tooltipInfo: PropTypes.string.isRequired,
};
export default ListCard;
